export const getTopTournamentsMatchesLimit = isMobileView => {
    return parseInt(
        isMobileView
            ? window.OPTIONS.properties['homepage.topTournaments.matchesLimit']
            : window.OPTIONS['topTournaments.matchesLimit']
    );
};
